import CockpitNotificationPagingResultModel from '../../generated/types/model/resource/CockpitNotificationPagingResultModel';

export default class CockpitNotificationPagingResultViewModel extends CockpitNotificationPagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
